import React from 'react'
import AobInvoice from '../../../types/aobInvoice'
import AccordionSection from '../../../common/AccordionSection'
import { formatMoney } from '../../../utils/money'

interface PatientPaymentProps {
  totalPatientOwes: number;
  invoice?: AobInvoice;
}

export default function PatientPaymentBlock({
  totalPatientOwes,
  invoice
}: PatientPaymentProps ) {
  return (
    <AccordionSection
      title="After insurance, you pay:"
      amount={formatMoney( totalPatientOwes )}
      toggleOpenText="Show Details"
      toggleCloseText="Hide Details"
    >
      <div className="inline-block pt-3 w-full">
        { ( invoice?.details?.length ) ? (
          <div>
            {invoice?.pap_setup_type === `Intake` &&
              invoice?.number_of_months !== undefined &&
              invoice?.est_monthly_due !== undefined && (
              <div className="flex justify-between w-full pb-4 text-graphite">
                <span>{`PAP Rental Initial Payment`}</span>
                <span>{formatMoney( invoice?.est_monthly_due )}</span>
              </div>
            )}
            {invoice?.details?.map( ( detail ) => (
              <div
                className="flex justify-between w-full pb-4 text-graphite"
                key={detail.dme_id}
              >
                <span>{detail.item_description}</span>
                <span>{formatMoney( detail.patient_owes )}</span>
              </div>
            ) )}
          </div>
        ): null}
      </div>
    </AccordionSection>
  )
}
